// @ts-nocheck



import CommonApi from './../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';

const convertDataToServer = (
licensePlateChangeCost) => (
{
  ...licensePlateChangeCost,
  cost: convertFromRubToKop(licensePlateChangeCost.cost)
});

const convertDataFromServer = (
licensePlateChangeCost) => (
{
  ...licensePlateChangeCost,
  cost: convertFromKopToRub(licensePlateChangeCost.cost)
});

const licensePlateChangeCost = new CommonApi(
  'licensePlateChangeCost',
  'Стоимость замены гос. номеров',
  convertDataToServer,
  convertDataFromServer
);

export default {
  ...licensePlateChangeCost
};
